import type {
	SingleCreativeCanvasStation,
	JuniorPlusMissionFullState,
} from '@mission.io/mission-toolkit'
import { useJuniorPlusStateSelector } from '../../../../../../context'

/**
 * Gets the data for a specific creative canvas station
 */
export function useCreativeCanvasData(
	canvasId: string
): null | SingleCreativeCanvasStation {
	return useJuniorPlusStateSelector((state: ?JuniorPlusMissionFullState) => {
		return state?.stationData.creativeCanvas.canvases[canvasId] || null
	})
}
